export const USER_QUERY = `
query (
  $id: ID!
) {
  user (
    id: $id
  ) {
    id
    company {
      id
      name
    }
    email
    name
    roles {
      id
      name
    }
  }
}
`

export const USERS_QUERY = `
query (
  $filters: [FilterInput]
  $pageNumber: Int
  $pageSize: Int
  $sorting: [SortingInput]
) {
  users (
    filters: $filters
    pageNumber: $pageNumber
    pageSize: $pageSize
    sorting: $sorting
  ) {
    data {
      id
      company {
        id
        name
      }
      email
      name
      roles {
        id
        name
      }
      createdAt
      updatedAt
    }
    total
  }
}
`
